import { render, staticRenderFns } from "./ReservationPurposeShow.vue?vue&type=template&id=316ebf0c&scoped=true&"
import script from "./ReservationPurposeShow.vue?vue&type=script&lang=js&"
export * from "./ReservationPurposeShow.vue?vue&type=script&lang=js&"
import style0 from "./ReservationPurposeShow.vue?vue&type=style&index=0&id=316ebf0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316ebf0c",
  null
  
)

export default component.exports